export const TITLE = "Fare restrictions";
export const DESCRIPTION =
  "This flight operates through multiple airlines. Below is the breakdown of fare restrictions for each individual flight. Ensure you’ve read and understood the differences in restrictions for each flight so you can plan accordingly.";
export const MAX_RESTRISCTIONS_TO_SHOW = 4;
